import { AdvancedExchangeRecommendationOutputSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/advanced-exchange-recommendation";
import { MerchantGuidedRecommendationOutputSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/merchant-guided-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/return-reasons";
import { VariantExchangeRecommendationsSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/variant-exchange-recommendations";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ExchangeRecommendationAgentSchema = z.enum([
  "merchantGuided",
  "variant",
  "advanced",
]);

export const ExchangeRecommendationChunkSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("merchantGuided"),
    data: MerchantGuidedRecommendationOutputSchema,
  }),
  z.object({
    type: z.literal("variant"),
    data: VariantExchangeRecommendationsSchema.optional(),
  }),
  z.object({
    type: z.literal("advanced"),
    data: AdvancedExchangeRecommendationOutputSchema,
  }),
]);

export type ExchangeRecommendationAgent = z.infer<
  typeof ExchangeRecommendationAgentSchema
>;
export type ExchangeRecommendationChunk = z.infer<
  typeof ExchangeRecommendationChunkSchema
>;

export const getExchangeRecommendationsStream = unaryStreamRpc({
  name: "getExchangeRecommendationsStream" as const,
  input: z.object({
    agents: z.array(ExchangeRecommendationAgentSchema),
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    otherProductsBeingReturned: z.array(ReturnProductSchema).optional(),
    returnReasons: z.array(ReturnReasonSchema),
    returnType: createEnum(ReturnTypeEnum).optional(),
    locale: z.string().optional(),
  }),
  output: ExchangeRecommendationChunkSchema,
});
